import styled from 'styled-components';

export const FeedbackWrapper = styled.div`
  flex: 1;
  display: flex;
`;
